<ng-template dsAttachTo="pageHeaderTitle">
  <h1 class="subheader-h1" role="heading" tabindex="0">Monitorowane podmioty w KRS</h1>
</ng-template>

<app-communicate-container
  *ngIf="newsletterKomunikat.tytul" 
  [formData]="newsletterKomunikat"
  [isSafeHtml]="true" 
  [isScrollIntoView]="true">
</app-communicate-container>

<div class="padding">
  <ds-tab-view [selectedIndex]="index"
               (onSelectedIndex)="tabChanged($event)"
               [actionSection]="true">
    <ds-tab-panel>
      <ds-tab-label>{{'subskrypcje'|transloco}}</ds-tab-label>
      <ds-tab-body>
        <app-subskrypcje></app-subskrypcje>
      </ds-tab-body>
    </ds-tab-panel>
    <ds-tab-panel>
      <ds-tab-label>{{'powiadomienia'|transloco}}</ds-tab-label>
      <ds-tab-body>
        <app-powiadomienia></app-powiadomienia>
      </ds-tab-body>
    </ds-tab-panel>
  </ds-tab-view>
</div>
